module.exports = ".ck-textarea{overflow-x:hidden}"